import React from 'react';
import moment from 'moment';
import { useSelector } from 'react-redux';
import { useStyles } from './DatetimeField.styled';

const DatetimeField = (props) => {
  const { datetime, tz = moment.tz.guess(), defaultValue = '--' } = props;
  const { localeFormat } = useSelector((state) => state.organizations);
  const classes = useStyles();

  if (!datetime) return defaultValue;

  return (
    <p>
      <span>{moment(datetime).tz(tz).format(`${localeFormat} hh:mm A`)}</span>
      <span className={classes.timezone}>{moment().tz(tz).format('UTC Z')}</span>
    </p>
  );
};

export { DatetimeField };
